var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_16_1",
    "data-name": "Component 16 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.7,
    height: 76.7,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M932.421,625.163l-10.035-10.035-.089-.088-1.32,1.321,8.5,8.5H902.864v1.922H929.39l-8.326,8.325-.087.089,1.32,1.322,10.11-10.111a.594.594,0,0,0,.3-.442A.959.959,0,0,0,932.421,625.163Z",
    transform: "translate(-874.293 -582.28)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M942.91,589.413a43.475,43.475,0,1,0,12.758,30.742A43.291,43.291,0,0,0,942.91,589.413Zm11.171,30.742a41.912,41.912,0,1,1-41.912-41.912A41.96,41.96,0,0,1,954.08,620.155Z",
    transform: "translate(-868.668 -576.655)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorNext);
export default __webpack_public_path__ + "static/media/cursor-next.9e646f9f.svg";
export { ForwardRef as ReactComponent };